import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import { useMutation, useQueryClient } from 'react-query';

import { useToast } from '@hooks';

import { useState } from 'react';

import { addFileToTask } from '@services/queries/tasks';
import { ITaskRawQuery } from '@models/Task.model';

import {
  Container,
  Overlay,
  Close,
  Header,
  Title,
  Confirm,
  Line,
  Form,
  Divider,
  Label,
  SelectFile,
  FileNamePreview,
} from './AddFileDialog.styles';

interface IAddFileDialog {
  open: boolean;
  onClose: () => void;
  task: ITaskRawQuery;
  closeOnFinish?: boolean;
}

export interface IPiorityForm {
  date: Date | null;
}

export const AddFileDialog = ({ open, onClose, task }: IAddFileDialog) => {
  const portalDiv = document.getElementById('portal');

  const { toast } = useToast();

  const queryClient = useQueryClient();

  const [file, setFile] = useState<File | undefined>(undefined);
  const [fileName, setFileName] = useState<string | null>(null);

  const addFileMutation = useMutation(addFileToTask, {
    onSuccess: async () => {
      toast.success('File added successfully');

      queryClient.invalidateQueries(['tasks']);

      onClose();
    },
    onError: () => {
      toast.error('Something got wrong');
    },
  });

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header>
              <Title>Add Attachment</Title>
              <Close onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </Close>
            </Header>
            <Divider height="28px" />

            <Label>Choose File</Label>
            <div>
              <SelectFile htmlFor="upload">Select File</SelectFile>
              <input
                type="file"
                id="upload"
                hidden
                accept="image/*"
                onChange={e => {
                  setFileName(e.target.files?.[0]?.name || '');
                  setFile(e.target.files?.[0]);
                }}
              />
            </div>

            <FileNamePreview>{fileName}</FileNamePreview>

            <Form>
              <Line>
                <Confirm
                  type="button"
                  disabled={addFileMutation.isLoading || !file}
                  onClick={() => {
                    if (!addFileMutation.isLoading && file) {
                      addFileMutation.mutate({
                        taskId: task.id,
                        file,
                      });
                    }
                  }}
                >
                  Save
                </Confirm>
              </Line>
            </Form>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
